export default "__VITE_ASSET__C86Nduj7__"